import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { Box, Button, TextField, Typography } from "@mui/material";
import {
  swalErrorMessage
} from "../../Constant/swalMessage";
import { commonStyles } from "../../assets/MUIStyles/commonStyles";
import { ReactComponent as ArrowBackIcon } from "../../assets/icons/arrow-back.svg";
import {
  changePasswordAction
} from "../NewDevelopment/Actions/CommonActions";
import NewAuthLayout from "./NewAuthLayout";

function VerifyPassword() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [spin, setSpin] = useState(false);
  const [state, setState] = useState<any>({
    password: "",
    cpassword: "",
  });
  const { password, cpassword } = state;
  const [errors, setErrors] = useState(false);
  const location = useLocation();
  const locSearch = new URLSearchParams(location.search);
  let token = locSearch.get("token");

  const resetPassword = async (e) => {
    e.preventDefault();
    setSpin(true);
    // console.log("password", password);
    if (
      password.length >= 8 &&
      /[A-Z]/.test(password) &&
      /[a-z]/.test(password) &&
      /\d/.test(password) &&
      /[!@#$%^&*()_+[\]{}|\\:;'"<>,.?/~`]/.test(password)
    ) {
      // console.log(password);
      // console.log(cpassword);
      if (password === cpassword) {
        let obj = {
          emailToken: token,
          password: password,
        };

        let res: any = await dispatch(changePasswordAction(obj));
        if (res) {
          history.push("/");
        }
      } else {
        swalErrorMessage("Password didn't match");
      }
    } else {
      setErrors(true);
    }

    setSpin(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <NewAuthLayout>
      <Typography className="font-28-700-grey">Reset Password</Typography>
      <Box mb={2}>
        <Typography className="font-14-grey mb-1">Password</Typography>
        <TextField
          name="password"
          value={password}
          type="password"
          onChange={handleChange}
          variant="outlined"
          fullWidth
          placeholder="Enter your new password"
          sx={commonStyles.inputField}
        />
      </Box>
      <Box mb={1}>
        <Typography className="font-14-grey mb-1">Confirm Password</Typography>
        <TextField
          name="cpassword"
          value={cpassword}
          onChange={handleChange}
          type={"password"}
          variant="outlined"
          fullWidth
          placeholder="Confirm your password"
          sx={commonStyles.inputField}
        />
      </Box>
      {errors && (
        <p style={{ color: "red" }}>
          Password must be at least 8 characters and must contain an uppercase,
          lowercase,numbers and special characters
        </p>
      )}
      <Button
        onClick={resetPassword}
        disabled={spin}
        variant="contained"
        sx={commonStyles.newAuthLoginButton}
        fullWidth
      >
        Reset Password
      </Button>

      <Typography className="font-14-400-grey" textAlign="center" mt={3}>
        <Link
          to="/login"
          className="flex-xy-center"
          style={{
            textDecoration: "none",
            color: "#1A1D23",
          }}
        >
          <ArrowBackIcon style={{ marginRight: 4 }} />
          Back to login
        </Link>
      </Typography>
    </NewAuthLayout>
  );
}

export default VerifyPassword;
